/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, {  useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import GlobalContext from '../../../../../../components/Context/GloablContext';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import ActivityExportFn from '../Export';


const ProviderActivateHistoryTopBar = ({
    title,
    path,
    pathPlaceholder,
    SearchInput,
    isColumnSelect,
    setIsColumnSelect,
    exportCols,
    username,
    isExport,
    setConfirmationState,data, exportProviders,isIdexport,isFilterOrganization,pathState}) => {
    const {setToastmessage,Toastmessage,toastErrorMessage,setToastErrorMessage,isSideBar} = useContext(GlobalContext);
    const navigate=useNavigate()
    const fileInputRef = useRef(null);
    const [isHover, setIsHover] = useState(false)
    const outSideClick = useRef();
    const selectedRows = useSelector(state => state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const ref = useRef()
    return (
        <div className="flex justify-between items-center mb-[14px]">
        
            {title!==undefined ?
                <h1 className="text-xl font-normal text-[#000000] xl:block hidden min-w-fit">{title}</h1>
                :
                pathPlaceholder &&
                <Link to={path} state={pathState !== undefined ? pathState : (username ? [username] : null)} className='hidden items-center min-w-max xl:flex'>
                    <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                    <span className='text-sm font-normal text-[#008586] pl-3'>{pathPlaceholder}</span>
                </Link>
               
            }
         
            <div className="flex items-center w-full justify-end relative">
                {(SearchInput||isExport)&&data!==undefined&&data?.data?.length>0&&<div>  <ActivityExportFn 
                    selectedRows={selectedRows}
                    exportProviders={exportProviders}
                    exportCols={exportCols}
                    isColumnSelect={isColumnSelect}
                    setIsColumnSelect={setIsColumnSelect}
                    isIdexport={isIdexport} username={username}
                    TotalCount={parseInt(data?.total_count)} />
                </div>}
            </div>
        </div>
    );
}

export default ProviderActivateHistoryTopBar;
